import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../firebase/AuthProvider';
import Loader from '../components/components/loader/Loader';

const RoleBasedGuard: React.FC = () => {
    const { currentRoles, isLoading } = useAuth();
    const location = useLocation();

    // Wait until roles are loaded or if currentRoles is not yet defined
    if (isLoading || currentRoles === null || currentRoles === undefined) {
        return <Loader />;
    }

    const isDeveloper = currentRoles?.some(role => role.name === 'DEVELOPER');
    const isAdmin = currentRoles?.some(role => role.name === 'ADMIN');

    console.log(currentRoles);

    if (isAdmin) {
        console.log("IS ADMIN")
        return <Outlet />;
    } else {
        console.log("Is NOT admin")
    }

    if (isDeveloper) {
        const allowedPaths = ['/issues', '/issue', '/login', '/logout', '/settings', '/profile', '/change-password', '/calendar', '/sprints', '/wiki'];
        if (allowedPaths.some(path => location.pathname.startsWith(path))) {
            return <Outlet />;
        } else {
            return <Navigate to="/issues" replace />;
        }
    }

    // For users who are not developers or admins
    const nonAdminDeveloperPaths = ['/issues', '/issue', '/sprints', '/wiki'];
    if (nonAdminDeveloperPaths.some(path => location.pathname.startsWith(path))) {
        return <Navigate to="/home" replace />;
    } else {
        return <Outlet />;
    }
};

export default RoleBasedGuard;
